function SoberTrackNotification() {
    this.__type = 'SobertrackNotification:www.veritracks.com';
    this.Id = -1;
    this.SMSNotificationPhoneNumber = '';
}
if (typeof exports !== 'undefined') {
    module.exports = SoberTrackNotification;
}